import React from "react"
import PropTypes from "prop-types"
import {
  Card,
  Segment,
  Divider,
  Label,
  Icon,
  Form,
  Button,
  Modal,
  Header,
} from "semantic-ui-react"
import bind from "bind-decorator"
import { coalesce } from "../utils/logical"
import {
  addNewMeasure,
  deleteFromInventory,
} from "../ducks/tabularData/inventory"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"

const DividerMargin = () => <Divider style={{ margin: "0.5rem 0" }} />

@withTranslation()
@connect(null, (dispatch) => ({
  addNewMeasure: (data, id) => dispatch(addNewMeasure(data, id)),
  deleteFromInventory: (id, invId) => dispatch(deleteFromInventory(id, invId)),
}))
export default class InventoryStockCard extends React.Component {
  constructor(props) {
    super(props)
    const {
      data: { name, purchasePrice, salePrice, remainder },
    } = this.props

    this.state = {
      editedData: {
        name: name.db,
        purchasePrice: purchasePrice.db,
        salePrice: salePrice.db,
        remainder: remainder.db,
      },
      isLoading: false,
      modal: false,
      chooseType: null,
      newMeasure: null,
      name: null,
      id: null,
      amount: null,
      purchasePrice: null,
      salePrice: null,
      measureId: [],
    }
  }

  componentDidMount() {
    let id
    if (this.props.data.measureId) {
      this.props.options.map((option) => {
        return option.value === this.props.data.measureId && (id = option.value)
      })
      if (this.state.measureId.length === 0) {
        this.setState({
          measureId: id,
        })
      }
    } else {
      if (!this.props.data.measureId) {
        this.setState({
          measureId: this.props.options[0].value,
        })
      }
    }
  }

  @bind
  stopLoading() {
    this.setState({
      isLoading: false,
    })
  }

  @bind
  startLoading() {
    this.setState({
      isLoading: true,
    })
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onChange({}, { value, name }) {
    this.setState({
      editedData: {
        ...this.state.editedData,
        [name]: value,
      },
    })
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onMeasureChange({}, { value }) {
    const { data } = this.props
    if (value === data.measureId) {
      this.setState({
        measureId: value,
        editedData: {
          name: coalesce(data.name.fixed, data.name.inventory),
          salePrice: coalesce(data.salePrice.fixed, data.salePrice.inventory),
          purchasePrice: coalesce(
            data.purchasePrice.fixed,
            data.purchasePrice.inventory,
          ),
          remainder: coalesce(data.remainder.fixed, data.remainder.inventory),
        },
      })
    }
    let salePrice, purchasePrice
    if (value !== data.measureId) {
      data.measures.map(
        (measure) =>
          measure.measureId === value &&
          ((salePrice = measure.price),
          (purchasePrice = measure.purchasePrice)),
      )
      this.setState({
        measureId: value,
        editedData: {
          name: coalesce(data.name.fixed, data.name.inventory),
          salePrice: salePrice,
          purchasePrice: purchasePrice,
          remainder: coalesce(data.remainder.fixed, data.remainder.inventory),
        },
      })
    }
  }

  @bind
  startEditing() {
    const { name, salePrice, purchasePrice, remainder } = this.props.data
    this.setState({
      editedData: {
        name: coalesce(name.fixed, name.inventory),
        salePrice: coalesce(salePrice.fixed, salePrice.inventory),
        purchasePrice: coalesce(
          purchasePrice.fixed,
          purchasePrice.inventory || 1,
        ),
        remainder: coalesce(remainder.fixed, remainder.inventory),
      },
    })
  }

  @bind
  cancelEditing() {
    this.setState({
      editedData: false,
    })
  }

  renderData() {
    const { data, measures, t } = this.props

    return (
      <div style={{ display: "flex", alignItems: "baseline" }}>
        <div style={{ flexGrow: 1 }}>
          <div>
            <u>
              <strong>{t("price").replace(", тг", "")}</strong>
            </u>
          </div>
          <div>
            <strong>{t("In storage")}: </strong>
            {data.salePrice.db}
          </div>
          <div>
            <strong>{t("new2")} </strong>
            {coalesce(data.salePrice.fixed, data.salePrice.inventory)}
          </div>

          <div>
            <u>
              <strong>{t("stock")}</strong>
            </u>
          </div>
          <div>
            <strong>{t("In storage")} </strong>
            {data.remainder.db}
          </div>
          <div>
            <strong>{t("new3")}</strong>
            {coalesce(data.remainder.fixed, data.remainder.inventory)}
          </div>
        </div>
        <div>
          <div>
            <u>
              <strong>{t("purchasePrice").replace(", тг", "")}</strong>
            </u>
          </div>
          <div>
            <strong>{t("In storage")}: </strong>
            {data.purchasePrice.db}
          </div>
          <div>
            <strong>{t("new2")} </strong>
            {coalesce(data.purchasePrice.fixed, data.purchasePrice.inventory)}
          </div>
          <DividerMargin />
          <div>
            <u>
              <strong>{t("unitsMeasuringFull")}</strong>
            </u>
          </div>
          <div>
            <strong>{t("In storage")} </strong>
            {data.measures.map(
              (m) =>
                m.isDefault && (
                  <span key={m.measureId} className="m_span">
                    {m.name}
                  </span>
                ),
            )}
          </div>
          <div>
            <strong>{t("new3")} </strong>
            {measures.map(
              (m) =>
                m.id === data.measureId && (
                  <span key={m.measureId} className="m_span">
                    {m.name}
                  </span>
                ),
            )}
          </div>
        </div>
      </div>
    )
  }
  @bind
  handleSubmit(e) {
    e.preventDefault()
    const { name, purchasePrice, remainder, salePrice } = this.state.editedData
    const { onEdit, data } = this.props
    // this.startLoading()
    if (!name) {
      this.setState({
        nameError: true,
      })
    } else {
      this.setState({
        nameError: false,
      })
    }
    if (!purchasePrice) {
      this.setState({
        purchasePriceError: true,
      })
    } else {
      this.setState({
        purchasePriceError: false,
      })
    }
    if (!remainder) {
      this.setState({
        remainderError: true,
      })
    } else {
      this.setState({
        remainderError: false,
      })
    }
    if (!salePrice) {
      this.setState({
        salePriceError: true,
      })
    } else {
      this.setState({
        salePriceError: false,
      })
    }
    if (name && purchasePrice && remainder && salePrice) {
      onEdit(
        {
          inventoryStockId: data.inventoryStockId,
          ...this.state.editedData,
          measureId: this.state.measureId,
        },
        this.stopLoading,
        this.props.inventoryId,
      )
      this.props.closeModal()
      /* this.setState({
        editedData: false,
      }) */
    }
  }

  @bind
  handleModal() {
    this.setState({
      modal: !this.state.modal,
      chooseType: null,
      newMeasure: null,
      name: null,
      id: null,
      amount: null,
      purchasePrice: null,
      salePrice: null,
      // editedData: false,
    })
  }

  @bind
  handleDeleteItem(e) {
    this.props.deleteFromInventory(e.target.id, this.props.inventoryId)
  }

  @bind
  handleSendNewMeasure() {
    let c = null
    if (this.state.chooseType === "1") {
      c = 1 * this.state.amount
      c.toString()
    }
    if (this.state.chooseType === "-1") {
      c = 1 / this.state.amount
      c.toString()
    }
    const sendData = {
      measureId: this.state.id,
      coef: parseFloat(c),
      isDefault: false,
      purchasePrice: this.state.purchasePrice
        ? parseFloat(this.state.purchasePrice)
        : null,
      price: this.state.salePrice ? parseFloat(this.state.salePrice) : null,
      barcode: this.props.data.barcode,
      storeId: this.props.data.storeId,
    }
    this.props.addNewMeasure(sendData, this.props.inventoryId)
    this.setState({
      modal: !this.state.modal,
      chooseType: null,
      newMeasure: null,
      name: null,
      id: null,
      amount: null,
      purchasePrice: null,
      salePrice: null,
    })
  }

  @bind
  handleModalSelectChange(e) {
    this.setState({
      chooseType: e.target.value,
    })
  }

  @bind
  handleModalMeasureChange(e) {
    this.props.measures.map(
      (m) =>
        m.shortName === e.target.value &&
        this.setState({
          newMeasure: e.target.value,
          name: m.name,
          id: m.id,
        }),
    )
  }

  @bind
  handleNewAmount(e) {
    this.setState({
      amount: e.target.value,
    })
  }

  @bind
  handleModalPrice(e) {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  renderEditingData() {
    const { data, options, t } = this.props
    const { editedData, isLoading } = this.state
    const { remainder } = data
    return (
      <>
        <Form style={{ marginTop: 15 }}>
          <Form.Input
            label={
              !remainder.db
                ? t("supplyTitle")
                : t("supplyTitle") + ": " + (data.name.db || "")
            }
            type="text"
            name="name"
            value={editedData.name || ""}
            onChange={this.onChange}
            error={this.state.nameError}
          />

          {this.state.nameError && (
            <Label basic color="red" pointing>
              {t("requiredField")}
            </Label>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 15,
              flexWrap: "wrap",
            }}
          >
            <div style={{ flexBasis: "48%" }}>
              <div>
                <Form.Input
                  label={
                    !remainder.db
                      ? t("purchasePrice2")
                      : t("purchasePrice2") + (data.purchasePrice.db || "")
                  }
                  type="number"
                  name="purchasePrice"
                  value={editedData.purchasePrice}
                  onChange={this.onChange}
                  error={this.state.purchasePriceError}
                />
                {this.state.purchasePriceError && (
                  <Label basic color="red" pointing>
                    {t("requiredField")}
                  </Label>
                )}
              </div>
              <div>
                <Form.Input
                  label={
                    !remainder.db
                      ? t("priceSale2")
                      : `${t("priceSale2")} :` + (data.salePrice.db || "")
                  }
                  type="number"
                  name="salePrice"
                  value={editedData.salePrice}
                  onChange={this.onChange}
                  error={this.state.salePriceError}
                />
                {this.state.salePriceError && (
                  <Label basic color="red" pointing>
                    {t("requiredField")}
                  </Label>
                )}
              </div>
            </div>
            <div style={{ flexBasis: "48%" }}>
              <div>
                <Form.Input
                  label={
                    !remainder.db
                      ? t("stock")
                      : t("stock") +
                        (data.remainder.db === 0
                          ? "0"
                          : data.remainder.db || "")
                  }
                  type="number"
                  name="remainder"
                  value={editedData.remainder}
                  onChange={this.onChange}
                  error={this.state.remainderError}
                />
                {this.state.remainderError && (
                  <Label basic color="red" pointing>
                    {t("requiredField")}
                  </Label>
                )}
              </div>

              <Form.Select
                label={t("unitsMeasuringFull")}
                options={options}
                onChange={this.onMeasureChange}
                value={this.state.measureId}
              />
            </div>
          </div>

          <Button color="green" onClick={this.handleSubmit} loading={isLoading}>
            {t("save")}
          </Button>
          <Button color="green" onClick={this.handleModal}>
            {t("addUnitsMeasuring")}
          </Button>
          <Button
            color="red"
            id={data.inventoryStockId}
            onClick={this.handleDeleteItem}
          >
            {t("delete")}
          </Button>
        </Form>
      </>
    )
  }

  render() {
    const {
      editedData,
      isLoading,
      modal,
      chooseType,
      newMeasure,
      name,
      amount,
      purchasePrice,
      salePrice,
    } = this.state
    const { data, completed, measures, t } = this.props
    return (
      <Card
        as={Segment}
        loading={isLoading}
        fluid
        style={{
          fontSize: 13,
          width: "80vw",
          height: "max-content",
          padding: "20px 15px",
        }}
        // className="inventory-stock-card"
      >
        <Card.Header>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontSize: 18 }}>
              <p>
                <b>Штрих-код: </b>
                {data.barcode}
              </p>
            </span>
            <div>
              <b>{t("employe")}: </b>
              <p style={{ display: "inline-block" }}>{data.authorLogin}</p>
              {/*              
                <>
                  <p>
                    <strong>{t("In storage")} </strong>
                    {data.name.db}
                  </p>

                  <p>
                    <strong>{t("new1")} </strong>
                    {coalesce(data.name.fixed, data.name.inventory)}
                  </p>
                </> */}
            </div>
          </div>
        </Card.Header>
        {modal && (
          <Modal
            size="small"
            open={modal}
            style={{ position: "fixed", top: "30%" }}
          >
            <Header content={data.name.db} />
            <Modal.Content>
              <div style={{ marginBottom: "7px" }}>
                <span>
                  <span style={{ fontSize: "16px" }}>
                    {data.measures.map((d) => d.isDefault && d.name)}
                  </span>
                  <select
                    className="modalSelect"
                    onChange={this.handleModalSelectChange}
                  >
                    <option disabled selected>
                      {t("select")}
                    </option>
                    <option value="1">содержит в себе</option>
                    <option value="-1">находится в</option>
                  </select>
                  {chooseType && (
                    <select
                      className="modalSelect"
                      onChange={this.handleModalMeasureChange}
                    >
                      <option disabled selected>
                        {t("selectUnitsMeasuring")}
                      </option>
                      {measures.map((m) => (
                        <option value={m.shortName} key={m.id}>
                          {m.name}
                        </option>
                      ))}
                    </select>
                  )}
                </span>
              </div>
              {chooseType === "1" && newMeasure !== null && (
                <>
                  <div style={{ marginBottom: "7px" }}>
                    <span style={{ fontSize: "16px" }}>
                      {name} в {data.measures.map((d) => d.isDefault && d.name)}{" "}
                      <input
                        type="number"
                        className="modalInput"
                        onChange={this.handleNewAmount}
                        value={amount}
                      />
                    </span>
                  </div>
                  <div style={{ marginBottom: "7px" }}>
                    <span style={{ fontSize: "16px" }}>
                      {t("purchasePrice2")}{" "}
                      <input
                        type="number"
                        className="modalInput"
                        onChange={this.handleModalPrice}
                        name="purchasePrice"
                        value={purchasePrice}
                      />{" "}
                      за {name}
                    </span>
                  </div>
                  <div style={{ marginBottom: "7px" }}>
                    <span style={{ fontSize: "16px" }}>
                      {t("priceSale2")}{" "}
                      <input
                        type="number"
                        className="modalInput"
                        onChange={this.handleModalPrice}
                        name="salePrice"
                        value={salePrice}
                      />{" "}
                      за {name}
                    </span>
                  </div>
                </>
              )}
              {chooseType === "-1" && newMeasure !== null && (
                <>
                  <div style={{ marginBottom: "7px" }}>
                    <span style={{ fontSize: "16px" }}>
                      в {name}{" "}
                      <input
                        type="number"
                        className="modalInput"
                        onChange={this.handleNewAmount}
                        value={amount}
                      />{" "}
                      {data.measures.map((d) => d.isDefault && d.name)}
                    </span>
                  </div>
                  <div style={{ marginBottom: "7px" }}>
                    <span style={{ fontSize: "16px" }}>
                      {t("purchasePrice2")}{" "}
                      <input
                        type="number"
                        className="modalInput"
                        onChange={this.handleModalPrice}
                        name="purchasePrice"
                        value={purchasePrice}
                      />{" "}
                      за {name}
                    </span>
                  </div>
                  <div style={{ marginBottom: "7px" }}>
                    <span style={{ fontSize: "16px" }}>
                      {t("priceSale2")}{" "}
                      <input
                        type="number"
                        className="modalInput"
                        onChange={this.handleModalPrice}
                        name="salePrice"
                        value={salePrice}
                      />{" "}
                      за {name}
                    </span>
                  </div>
                </>
              )}
            </Modal.Content>
            <Modal.Actions>
              <Button content={t("cancel")} onClick={this.handleModal} />
              <Button
                color="green"
                content={t("save")}
                onClick={this.handleSendNewMeasure}
              />
            </Modal.Actions>
          </Modal>
        )}

        {editedData ? this.renderEditingData() : this.renderData()}
      </Card>
    )
  }
}

InventoryStockCard.propTypes = {
  onEdit: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
}
